import { releaseQuery, visitorLogQuery } from '../ReportsAPI';
import {
    createReleaseByTurbineID,
    createVisitorByTurbineID,
    createUniqueArrayByKey,
} from './helpers/maintenance.helper';
import { getSelectedItems, getTurbineIdToNameMap } from 'common/state.helper';
import { Logger } from 'common/logger';

const initialState = {
    timelineData: [],
};

export const overviewReleaseChart = {
    name: 'overviewReleaseChart',
    state: initialState,

    reducers: {
        setTimelineData(state, timelineData) {
            return { ...state, timelineData };
        },
    },

    effects: (dispatch) => ({
        async loadAll(_, state) {
            const { selectedDate, selectedParkId } = getSelectedItems(state);
            const filterByReturnTime = ({ return_time }) => !!return_time;
            const filterByEndTime = ({ end_time }) => !!end_time;

            const entityKeyToNameMap = getTurbineIdToNameMap(state);

            const prepareData = async (query, filter, createFn) => {
                try {
                    const response = await query(selectedDate, selectedParkId);

                    const filteredResponse = response.data.filter((entry) => {
                        const entityKey = entry.turbine_id;
                        return filter(entry) && entityKeyToNameMap[entityKey];
                    });

                    const data = createUniqueArrayByKey(filteredResponse);
                    const result = data.map((item) => createFn(item, selectedDate, entityKeyToNameMap));

                    return result;
                } catch (e) {
                    Logger.debug('There was an error in prepareData, returning an empty array', e);
                    return [];
                }
            };

            const timelineData = [
                ...(await prepareData(releaseQuery, filterByReturnTime, createReleaseByTurbineID)),
                ...(await prepareData(visitorLogQuery, filterByEndTime, createVisitorByTurbineID)),
            ];

            dispatch.overviewReleaseChart.setTimelineData(timelineData);
        },
    }),
};

export default overviewReleaseChart;
